import { autoinject } from "aurelia-framework";
import { User, UserManager } from "oidc-client";

import { IRequestHandler } from "../../interfaces/i-handlers";

@autoinject()
export class UserChatHandler implements IRequestHandler {
    private _userManager: UserManager;

    public constructor(userManager: UserManager) {
        this._userManager = userManager;
    }

    public async handle(request: Request): Promise<void> {
        let user: User = await this._userManager.getUser();
        if (user != null) {
            if (!request.headers.get("X-Chat-User")) {
                request.headers.append("X-Chat-User", user.profile.sub);
            }
        } else {
            console.log("User is not logged in, no user id set.");
        }
    }
}
